import React from 'react';
import { Box } from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

/**
 * Reusable Area Chart component for sales performance
 * @param {Array} data - Chart data with timeSlot, dineIn, pickUp properties
 * @param {Object} customStyles - Optional custom styling for the container
 */
const SalesAreaChart = ({ data, customStyles = {} }) => {
  return (
    <Box sx={{ width: "100%", overflowX: "auto", ...customStyles }}>
      <ResponsiveContainer width="100%" height={400}>
        <AreaChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <defs>
            <linearGradient id="dineInAreaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1976d2" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#1976d2" stopOpacity={0.1} />
            </linearGradient>
            <linearGradient id="pickUpAreaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#00897b" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#00897b" stopOpacity={0.1} />
            </linearGradient>
            <linearGradient id="deliveryAreaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#6a1b9a" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#6a1b9a" stopOpacity={0.1} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="timeSlot"
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fontSize: 12 }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip
            formatter={(value) => [`₹${value.toLocaleString()}`, '']}
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              fontSize: "14px",
            }}
            labelFormatter={(label) => `Time Slot: ${label}`}
          />
          <Legend wrapperStyle={{ paddingTop: '20px' }} />
          <Area
            type="monotone"
            dataKey="dineIn"
            stackId="1"
            stroke="#1976d2"
            fill="url(#dineInAreaGradient)"
            name="Dine In"
            animationDuration={1500}
            animationBegin={0}
          />
          <Area
            type="monotone"
            dataKey="pickUp"
            stackId="1"
            stroke="#00897b"
            fill="url(#pickUpAreaGradient)"
            name="Pick Up"
            animationDuration={1500}
            animationBegin={300}
          />
          <Area
            type="monotone"
            dataKey="delivery"
            stackId="1"
            stroke="#6a1b9a"
            fill="url(#deliveryAreaGradient)"
            name="Delivery"
            animationDuration={1500}
            animationBegin={600}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default SalesAreaChart;
